module.exports = __webpack_public_path__ + "img/Flag_of_Togo.1f722bbe.svg";